import { MOKA_INVENTORY_API } from 'api/constants';

export const V1_RECIPES = `${MOKA_INVENTORY_API}/v1/recipes`;
export const V1_IMPORT_RECIPES_TEMPLATE = `${V1_RECIPES}/import_recipes_template`;
export const V1_EXPORT_RECIPES = `${V1_RECIPES}/export`;
export const V1_IMPORT_RECIPES = `${V1_RECIPES}/import`;
export const V1_GET_ITEM_DROPDOWN = `${MOKA_INVENTORY_API}/v1/items/item_dropdowns`;
export const GET_ITEM_VARIANT = id =>
  `${MOKA_INVENTORY_API}/v1/items/${id}/item_variants`;
export const GET_ITEM_INGREDIENT = (page, perPage, keyword) =>
  `${MOKA_INVENTORY_API}/v1/ingredients?page=${page}&per_page=${perPage}&keyword=${keyword}`;
export const DELETE_RECIPES_BY_ID = id =>
  `${MOKA_INVENTORY_API}/v1/recipes/${id}`;
export const CREATE_RECIPES = `${MOKA_INVENTORY_API}/v1/recipes`;
export const CREATE_ALL_OUTLET_RECIPES = `${MOKA_INVENTORY_API}/v1/recipes/create_all_outlets`;
export const UPDATE_RECIPES = id => `${MOKA_INVENTORY_API}/v1/recipes/${id}`;
export const UPDATE_RECIPES_ALL_OUTLET = id =>
  `${MOKA_INVENTORY_API}/v1/recipes/${id}/update_all_outlets`;
export const GET_RECIPE_BY_VARIANT_ID = id =>
  `${MOKA_INVENTORY_API}/v1/recipes/item_variant/${id}`;
export const PUSHER_CHANNEL = 'library/recipes/export';
